var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"text-center mt-10 mx-10"},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }